// employeePositions/slice.js

import { employeePositionsInitialState } from "./employeePositionsState";
import { makeEmployeePositionsActions } from "./employeePositionsActions";

export const createEmployeePositionsSlice = (set, get) => ({
  employeePositions: employeePositionsInitialState,
  employeePositionsActions: Object.freeze(
    makeEmployeePositionsActions(set, get)
  ),
});
